import React from 'react';
import { Divider } from 'antd';
import './GenAiTabs.less';

interface IGenAiTabsProps {
  tabs: Array<string>;
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}

const GenAiTabs: React.FC<IGenAiTabsProps> = ({ tabs, activeTab, setActiveTab }) => {
  const handleClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className="tabs-container">
      <div className={`tab ${activeTab === 0 ? 'active' : ''}`} onClick={() => handleClick(0)}>
        {tabs[0]}
      </div>
      <Divider type="vertical" />
      <div className={`tab ${activeTab === 1 ? 'active' : ''}`} onClick={() => handleClick(1)}>
        {tabs[1]}
      </div>
    </div>
  );
};

export default GenAiTabs;
